import React, { Component } from 'react'
import styled from 'styled-components'

import Masonry from 'react-masonry-css'
import ReactSwipe from 'react-swipe'
import ScrollMenu from 'react-horizontal-scrolling-menu'

import moment, { lang } from 'moment'
import 'moment/locale/fr'

import Header from '../Header/Header'
import Kiosk from '../Kiosk/Kiosk'
import Settings from 'settings'

import styles from './MobileView.module.css'
import { getLanguage } from '../../utils/Locale'

const Wrapper = styled.div`
    background-color: ${props => props.theme.background};
`

const DaySelection = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => props.count}, 1fr);
    margin-top: 8px;

    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    
    min-width: 100vw;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    background-color: #fff;
    height: 40px;
    overflow-x: auto;

    /* min-width: ${props => props.width}vw;  */
    width: fit-content;

    @media screen and (max-width: 1024px) {
        margin-top: 0;
    }
`

const DayLink = styled.div`
    margin-left: 3px;
    margin-right: 3px;
    color: ${props =>
        props.active ? props.theme.active_day_color || '#000' : '#4e4e4e'};
    border-bottom: ${props =>
        props.active
            ? '2px solid ' + (props.theme.active_day_color || '#000')
            : '2px solid transparent'};

    min-width: 190px;
    @media screen and (max-width: 1024px) {
        min-width: 150px;
    }
    text-align: center;
    outline: none;
    padding-top: 0.5em;
`

const DaysWrapper = styled.div`
    margin-top: 8px;

    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    background-color: #fff;
    /* height: 40px; */
    @media screen and (max-width: 1024px) {
        margin-top: 0;
    }
    .active-custom {
        outline: none !important;
    }

    .item-custom:focus {
        outline: none !important;
    }
`

const DateLabel = styled.div`
    font-size: 0.8em;
    font-weight: 600;
`

const DayLabel = styled.div``

const Arrow = styled.span`
    display: inline-block;
    height: 28px;
    width: 28px;
    border-radius: 9999px;
    color: #70757a;
    background-color: #fff;
    /* box-shadow: 0 0 0 1px rgba(0,0,0,0.04), 0 4px 8px 0 rgba(0,0,0,0.20); */
    cursor: pointer;
    svg {
        height: 100%;
        fill: #000;
        :hover {
            fill: #555;
        }
    }
`

const InformationBloc = styled.p`
    padding: 0 2em;
    font-size: 0.8em;
    font-weight: 600;
`

const ArrowLeft = () => {
    return (
        <Arrow>
            <svg focusable="false" viewBox="0 0 24 24">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
        </Arrow>
    )
}

const ArrowRight = () => {
    return (
        <Arrow>
            <svg focusable="false" viewBox="0 0 24 24">
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
        </Arrow>
    )
}

class MobileView extends Component {
    reactSwipeEl = null
    daysBand = null

    state = {
        date: null,
        selectedIndex: this.props.startIndex,
    }

    componentDidMount() {
        const selectedDay = document.getElementById(
            `day-${this.props.startIndex}`
        )
        if (this.daysBand) {
            this.daysBand.scrollTo(
                selectedDay.offsetLeft -
                    document.body.clientWidth / 2 +
                    selectedDay.clientWidth / 2,
                0
            )
        }
        if (this.scrollMenuRef) {
            this.scrollMenuRef.scrollTo(`${this.props.startIndex}`)
        }
    }

    goToDate = (date, index) => {
        this.reactSwipeEl.slide(index)
        this.setState({
            date: date,
        })
    }

    onTransitionEnd = index => {
        this.setState({
            date: this.props.items[index].date,
            selectedIndex: index,
        })
        const selectedDay = document.getElementById(`day-${index}`)
        if (this.daysBand) {
            this.daysBand.scrollTo(
                selectedDay.offsetLeft -
                    document.body.clientWidth / 2 +
                    selectedDay.clientWidth / 2,
                0
            )
        }

        if (this.scrollMenuRef) {
            this.scrollMenuRef.scrollTo(`${index}`)
        }
    }

    swipeOptions = {
        startSlide: this.state.selectedIndex,
        transitionEnd: this.onTransitionEnd,
    }

    onSelect = key => {
        this.setState({ selectedIndex: key })
    }

    render() {
        const {
            title,
            subtitle,
            language = '',
            currency,
            useCommercialName,
            hideComposition,
            hideLabels,
            hideIntolerences,
            dataSource,
            hideMenuPrice,
            hideRecipePoints,
            hideEnergyKcal,
            showEnergyKcalByPortion
        } = this.props
        if (!this.props.items || this.props.items.length === 0) {
            //return <p>Waiting...</p>
            return (
                <Wrapper className={styles.grid}>
                    <div className={styles.item}>
                        <img
                            style={{ maxWidth: '100%' }}
                            src={`img/no_menu_${language}.png`}
                        />
                    </div>
                </Wrapper>
            )
        }
        const { items = [] } = this.props
        const currentDay = items[this.state.selectedIndex] || {}
        const { date } = currentDay

        const headerTitle =
            title || Settings.translations[getLanguage(language)].today
        const headerSubtitle = `${moment(date)
            .locale(getLanguage(language))
            .format('LL')}`
        const breakpointColumnsObj = {
            default: 3,
            900: 2,
            500: 1,
        }

        const fullContent = this.props.items.map((item, index) => {
            let isKiosksEmpty = true
            if (item.kiosks && item.kiosks.length) {
                item.kiosks.map(kiosk => {
                    if (kiosk.items.length) {
                        isKiosksEmpty = false
                    }
                })
            }
            if (isKiosksEmpty) {
                return (
                    <Wrapper key={index} className={styles.grid}>
                        <div className={styles.item}>
                            <img
                                style={{ maxWidth: '100%' }}
                                src={`img/no_menu_${language}.png`}
                            />
                        </div>
                    </Wrapper>
                )
            }

            const kiosksRender = []
            item.kiosks.map(
                ({ items = [], name = '', kioskPicture = '' }, index) => {
                    if (items.length !== 0) {
                        kiosksRender.push(
                            <div key={index} className={styles.item}>
                                <Kiosk
                                    name={name}
                                    items={items}
                                    concept={this.props.concept}
                                    currency={currency}
                                    kioskPicture={kioskPicture}
                                    useCommercialName={useCommercialName}
                                    hideComposition={hideComposition}
                                    hideLabels={hideLabels}
                                    hideIntolerences={hideIntolerences}
                                    dataSource={dataSource}
                                    hideMenuPrice={hideMenuPrice}
                                    hideRecipePoints={hideRecipePoints}
                                    hideEnergyKcal={hideEnergyKcal}
                                    showEnergyKcalByPortion={showEnergyKcalByPortion}
                                />
                            </div>
                        )
                    }
                }
            )
            return (
                <div key={index}>
                    <Masonry
                        columnClassName={''}
                        breakpointCols={breakpointColumnsObj}
                        className={styles.grid}
                    >
                        {kiosksRender}
                    </Masonry>
                </div>
            )
        })

        let days = null
        if (this.props.items.length > 1) {
            days = this.props.items.map((item, index) => {
                const itemDate = moment(item.date)
                    .locale(getLanguage(language))
                    .format('YYYY-MM-DD')
                const dayLabel = moment(item.date)
                    .locale(getLanguage(language))
                    .format('dddd')
                const dateLabel = moment(item.date)
                    .locale(getLanguage(language))
                    .format('D/M')
                return (
                    <DayLink
                        key={index}
                        id={`day-${index}`}
                        className={styles.dayLink}
                        active={this.state.selectedIndex === index}
                        onClick={date => this.goToDate(itemDate, index)}
                    >
                        <DateLabel>{dateLabel}</DateLabel>
                        <DayLabel>{dayLabel}</DayLabel>
                    </DayLink>
                )
            })
        }

        const daysBar = (
            <ScrollMenu
                ref={r => (this.scrollMenuRef = r)}
                data={days}
                arrowLeft={ArrowLeft()}
                arrowRight={ArrowRight()}
                selected={this.state.selectedIndex}
                onSelect={this.onSelect}
                alignCenter={true}
                scrollToSelected={true}
                hideArrows={true}
                itemClass={'item-custom'}
                itemClassActive={'active-custom'}
            />
        )

        return (
            <div className={styles.dailyMenu}>
                <Header
                    title={headerTitle}
                    subtitle={subtitle}
                    date={headerSubtitle}
                    concept={this.props.concept}
                    mode="day"
                />

                {/* {days ? (
                    <div
                        ref={el => (this.daysBand = el)}
                        id="days-band"
                        className={styles.dayBar}
                    >
                        <DaySelection
                            ref={el => (this.daysBand2 = el)}
                            count={this.props.items.length}
                            width={(this.props.items.length / 7) * 100}
                        >
                            {days}
                        </DaySelection>
                    </div>
                ) : null} */}

                {subtitle && <InformationBloc>{subtitle}</InformationBloc>}

                {days ? (
                    <DaysWrapper count={this.props.items.length}>
                        {daysBar}
                    </DaysWrapper>
                ) : null}

                <ReactSwipe
                    childCount={fullContent.length}
                    swipeOptions={this.swipeOptions}
                    transitionEnd={this.onTransitionEnd}
                    ref={el => (this.reactSwipeEl = el)}
                >
                    {fullContent}
                </ReactSwipe>
            </div>
        )
    }
}

export default MobileView
